var parallaxList = [...document.querySelectorAll('.parallax__container')];
var bigList = [...document.querySelectorAll('.bst__container')];

var combList = parallaxList.concat(bigList);

var p_options = {
  rootMargin: '0px 0px 500px 0px',
  threshold: 0.0
}

var parent_coords = [];

window.addEventListener("load", combList.forEach(resetCoords));

function resetCoords(elem, i) {
  parent_coords[i] = elem.getBoundingClientRect().top + window.pageYOffset - 148;
}

window.addEventListener("load", function(){
  let p_observer = new IntersectionObserver(reveal, p_options);

  function reveal(blocks){
    blocks.forEach((block, i) => {
      
      if(block.isIntersecting) {    
          for (let j = 0; j < block.target.children.length; j++) {
            let speed = block.target.children[j].getAttribute('scroll-speed');
            let scale = block.target.children[j].getAttribute('scroll-scale');
            if(block == '.bst__container') {
              block.target.children[j].style.transform = "translate3d(0px, " + ((window.pageYOffset - parent_coords[i]) * speed) + "px, 0px)";
            } else {
              block.target.children[j].style.transform = "translate3d(0px, " + ((window.pageYOffset - parent_coords[i]) * speed) + "px, 0px) scale(" + scale + ")";
            }
          }
      };
    })  
  }

  combList.forEach(item =>{
    p_observer.observe(item); 
  })
})

window.addEventListener("resize", function(){
    combList.forEach((block, i) => {
      parent_coords[i] = block.getBoundingClientRect().top + window.pageYOffset - 148;
   
          for (let j = 0; j < block.children.length; j++) {
            let speed = block.children[j].getAttribute('scroll-speed');
            let scale = block.children[j].getAttribute('scroll-scale');
            if(block == '.bst__container') {
              block.children[j].style.transform = "translate3d(0px, " + ((window.pageYOffset - parent_coords[i]) * speed) + "px, 0px)";
            } else {
            block.children[j].style.transform = "translate3d(0px, " + ((window.pageYOffset - parent_coords[i]) * speed) + "px, 0px) scale(" + scale + ")";
            }
          }
    })  
})

window.addEventListener("scroll", function(){
  let p_observer = new IntersectionObserver(reveal, p_options);

  function reveal(blocks){
    blocks.forEach((block, i) => {
      
      if(block.isIntersecting) {    
          for (let j = 0; j < block.target.children.length; j++) {
            let speed = block.target.children[j].getAttribute('scroll-speed');
            let scale = block.target.children[j].getAttribute('scroll-scale');
            if(block == '.bst__container') {
              block.target.children[j].style.transform = "translate3d(0px, " + ((window.pageYOffset - parent_coords[i]) * speed) + "px, 0px)";
            } else {
              block.target.children[j].style.transform = "translate3d(0px, " + ((window.pageYOffset - parent_coords[i]) * speed) + "px, 0px) scale(" + scale + ")";
            }
          }
      };
    })  
  }

  combList.forEach(item =>{
    p_observer.observe(item); 
  })
})